import React from "react";
import "../../components/Expense/ExpList.css";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import CryptoJS from "crypto-js";

const ExpList = ({ fieldOpsResponse }) => {

  const handleDetailClick = (relocationId) => {
    // navigate(`/FieldOpsExpenseList?Relocation_Id=${relocationId}`);
    const key = "dbbworldwidepvtltd";
    const encryptedRelocationID = encryptRelocationID(relocationId, key);

    const url = `/RelocationExpenseDetail?Relocation_Id=${encryptedRelocationID}`;
    window.open(url, "_blank");
  };

  const handleAddExpenseClick = (relocationId) => {
    // navigate(`/AddFieldOpsExpense?Relocation_Id=${relocationId}`);
    const key = "dbbworldwidepvtltd";
    const encryptedRelocationID = encryptRelocationID(relocationId, key);

    const url = `/AddFieldOpsExpense?Relocation_Id=${encryptedRelocationID}`;
    window.open(url, "_blank");
  };

  function encryptRelocationID(relocationId, key) {
    const ciphertext = CryptoJS.AES.encrypt(
      relocationId.toString(),
      key
    ).toString();
    return encodeURIComponent(ciphertext);
  }

  return (
    <div className="container-fluid">
      <div className="expenseList">
        <table className="expenseListTable"
          style={{ marginBottom: "1rem", borderRadius: "17px 15px 0px 0px" }}
        >
          <tr>
            <th
              colSpan={8}
              style={{
                backgroundColor: "#5B489D",
                color: "white",
                fontSize: "20px",
              }}
            >
              {" "}
              Expense List
            </th>
          </tr>
        </table>
        <table className="detailsTable">
         
            <tr className="employeeListHeading">
              <th>S.No.</th>
              <th>Lead ID</th>
              <th>Full Name</th>              
              <th>Contact No.</th>
              <th>Lead Owner</th>
              <th>Expense Amount</th>
              <th>Details</th>
              {/* <th>Add Expense</th> */}
            </tr>
          
          
            {fieldOpsResponse !== null ? (
              fieldOpsResponse.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.Relocation_ID}</td>
                  <td>{item.First_Name}</td>                  
                  <td>{item.Mobile_No}</td>
                  <td>{item.Assigned_To}</td>
                  <td>{item.Expense_Amount}</td>
                  <td>
                    <a
                      onClick={() => handleDetailClick(item.Relocation_ID)}
                      style={{
                        cursor: "pointer",
                        marginLeft: "13px",
                        color: "#6a6a6a",
                        textDecoration: "none",
                      }}
                    >
                      <SearchIcon />
                    </a>
                  </td>
                  {/* <td>
                    <a
                      onClick={() => handleAddExpenseClick(item.Relocation_ID)}
                      
                    >
                      <button className="addExpenseButton">
                       <AddIcon className="icon" /> Add Expense 
                      </button>
                    </a>
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="15">No suppliers available</td>
              </tr>
            )}
         
        </table>
      </div>
    </div>
  );
};

export default ExpList;
